var zipcodes_config = {
    sixpoint: {
        "title": "NY",
        "zip_prefixes": "00,10,11,12,13,14",
        "url": "https:\/\/flagship-powered-by-taprm.myshopify.com"
    },
    taprmUS: {
        "title": "U.S.",
        "zip_prefixes": "01,02,03,05,06,07,08,20,22,23,24,27,28,29,30,31,32,33,34,39,40,41,42,43,44,45,46,47,53,54,55,56,58,59,63,64,65,66,67,68,69,70,71,72,80,81,82,83,85,86,87,88,89,90,91,92,93,94,95,96,97,99",
        "url": "http:\/\/us.taprm.com"
    },
    taprmPA: {
        "title": "PA",
        "zip_prefixes": "15,16,17,18,19",
        "url": "http:\/\/pa.taprm.com"
    }
}

var cart_page_config = {
    // end hour for Tuesday, Moday, Sunday
    specialDaysHour: 19,
    // end hour for all days
    allDaysHour: 19,
    // [start_interval, end_interval, value, option]
    defaultCheckoutInterval: [
        [12, 19, 'ASAP', 'ASAP'],
        [0, 11, '01:00PM-03:00PM', '1:00PM to 3:00PM'],
        [0, 12, '02:00PM-04:00PM', '2:00PM to 4:00PM'],
        [0, 13, '03:00PM-05:00PM', '3:00PM to 5:00PM'],
        [0, 14, '04:00PM-06:00PM', '4:00PM to 6:00PM'],
        [0, 15, '05:00PM-07:00PM', '5:00PM to 7:00PM'],
        [0, 16, '06:00PM-08:00PM', '6:00PM to 8:00PM'],
        [0, 17, '07:00PM-09:00PM', '7:00PM to 9:00PM']
    ],
    // "Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"
    checkoutIntervalPerDays: {
        'Sunday': [],
        'Monday': [],
        'Tuesday': [],
        'Wednesday': [],
        'Thursday': [],
        'Friday': [],
        'Saturday': [],
    },
    sameDayOptions: [
        [0, 17, 'Next Day Delivery', 'Next Day Delivery']
    ],
    sameDayMaxTime: 17,
    disableSameDay: ["2021-05-31", "2021-08-22", "2021-08-23"],
    disableOnDemandDay: ["2021-05-31", "2021-08-22", "2021-08-23"]
}
